import script from "./QuoteView.vue?vue&type=script&setup=true&lang=js"
export * from "./QuoteView.vue?vue&type=script&setup=true&lang=js"

import "./QuoteView.vue?vue&type=style&index=0&id=03f94d8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03f94d8d"]])

export default __exports__